/**
 * Area Picker — shown right after login, before the full workspace shell ever
 * mounts, for partners who have BOTH the full Arbeitsbereich (FlexLayout /
 * Tool Hub / Browser) AND the simplified Sales-Landing available. Mirrors
 * VariantPicker's visual language (same full-screen centered-card look).
 *
 * The choice is remembered in sessionStorage for this browser tab; a small
 * switch link in both destinations (AppContent's top bar / SalesLanding's
 * header) lets the user change their mind without logging out.
 */

import { useAuth } from '../contexts/AuthContext';

export const AREA_STORAGE_KEY = 'cui-area-picked';

export function pickArea(area: 'work' | 'sales'): void {
  try { sessionStorage.setItem(AREA_STORAGE_KEY, area); } catch { /* ignore */ }
  window.location.reload();
}

export function currentAreaChoice(): 'work' | 'sales' | null {
  try {
    const v = sessionStorage.getItem(AREA_STORAGE_KEY);
    return v === 'work' || v === 'sales' ? v : null;
  } catch {
    return null;
  }
}

const OPTIONS: { value: 'work' | 'sales'; label: string; description: string }[] = [
  { value: 'sales', label: 'Sales', description: 'Chat, Nachrichten, Kunden, Unterlagen — alles für den Vertrieb.' },
  { value: 'work', label: 'Arbeitsbereich', description: 'Die volle Entwickler-Oberfläche — Panels, Browser, Dateien.' },
];

export default function AreaPicker() {
  const { user } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--tnfh-0a0a0f)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      padding: '1rem',
    }}>
      <div style={{ maxWidth: 440, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: '#ffffff', marginBottom: 8 }}>
            Wo möchtest du hin?
          </h1>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)' }}>
            {user?.name ? `Angemeldet als ${user.name}` : 'Wähle deinen Bereich'}
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {OPTIONS.map(o => (
            <button
              key={o.value}
              data-ai-id={`area-picker-choose-${o.value}`}
              onClick={() => pickArea(o.value)}
              style={{
                textAlign: 'left',
                padding: '18px 20px',
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 14,
                color: '#ffffff',
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              <div style={{ fontSize: 16, fontWeight: 600 }}>{o.label}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>
                {o.description}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
